module.exports = __webpack_public_path__ + "img/tool.98859813.png";